import React, { Component } from 'react';
import Scriba from 'react-scriba';
import { DataTicket } from '../../data/DataTicket';
import { Immocom } from '../../specifique/immocom';
import { ComboBoxPhaseHub } from '../ComboBox/ComboBoxPhaseHub';
import { ComboBoxProjetHub } from '../ComboBox/ComboBoxProjetHub';
import { ComboBoxSalariesScribaNet } from '../ComboBox/ComboBoxSalariesScribaNet';
import { ComboBoxStatutEventHub } from '../ComboBox/ComboBoxStatutEventHub';
import { ComboBoxTacheHub } from '../ComboBox/ComboBoxTacheHub';
import { EUIPanel } from '../EUI/EUIPanel';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';
import { TextFieldTemps } from '../TextField/TextFieldTemps';

export class FicheEvenementHub extends Component {

    static defaultProps = {
        idTicket: undefined,
        idEvenement: undefined,
        isOpen: false,
        /* --- */
        onDismiss: () => null,
        onSave: () => null,
    };

    static defaultState = {
        evenementHub: {},
        onActiveBoutonEnregistrer: false,
    };

    constructor(props) {
        super(props);
        this.state = { ...FicheEvenementHub.defaultState };
    };

    _chargementDonnees = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Chargement de l\'évènement'
        });

        const { idTicket, idEvenement } = this.props;
        DataTicket._chargementFicheEvenementHub(idTicket, idEvenement).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                let evenementHub = responseFetch.reponseAPIobjet;

                if (evenementHub) {
                    /* Temps passé */
                    if (evenementHub.tempsPasse && evenementHub.tempsPasse < 60) { // less than an hour
                        evenementHub.tempsPasseFormate = evenementHub.tempsPasse;
                        evenementHub.tempsPasseType = 'Minute';
                    }
                    else if (evenementHub.tempsPasse && evenementHub.tempsPasse >= 60 && evenementHub.tempsPasse <= (7 * 60)) { // more than an hour and less than a day
                        evenementHub.tempsPasseFormate = Math.round(evenementHub.tempsPasse / 60);
                        evenementHub.tempsPasseType = 'Heure';
                    }
                    else if (evenementHub.tempsPasse) { // more than a day
                        evenementHub.tempsPasseFormate = Math.round(evenementHub.tempsPasse / (7 * 60));
                        evenementHub.tempsPasseType = 'Jour';
                    }

                    /* Temps débité */
                    if (evenementHub.tempsDebite && evenementHub.tempsDebite < 60) { // less than an hour
                        evenementHub.tempsDebiteFormate = evenementHub.tempsDebite;
                        evenementHub.tempsDebiteType = 'Minute';
                    }
                    else if (evenementHub.tempsDebite && evenementHub.tempsDebite >= 60 && evenementHub.tempsDebite <= (7 * 60)) { // more than an hour and less than a day
                        evenementHub.tempsDebiteFormate = Math.round(evenementHub.tempsDebite / 60);
                        evenementHub.tempsDebiteType = 'Heure';
                    }
                    else if (evenementHub.tempsDebite) { // more than a day
                        evenementHub.tempsDebiteFormate = Math.round(evenementHub.tempsDebite / (7 * 60));
                        evenementHub.tempsDebiteType = 'Jour';
                    }

                    switch (evenementHub.emailPersonne) {
                        case "afolin@oci.fr":
                            evenementHub.assigneA = "AF";
                            break;
                        case "bleviez@oci.fr":
                            evenementHub.assigneA = "BL";
                            break;
                        case "cboisgontier@oci.fr":
                            evenementHub.assigneA = "CB";
                            break;
                        case "fpoupelain@oci.fr":
                            evenementHub.assigneA = "FP";
                            break;
                        case "gjacques@oci.fr":
                            evenementHub.assigneA = "GJ";
                            break;
                        case "kpeeters@oci.fr":
                            evenementHub.assigneA = "KP";
                            break;
                        case "mgolchin@oci.fr":
                            evenementHub.assigneA = "MG";
                            break;
                        case "ydelporte@oci.fr":
                            evenementHub.assigneA = "YD";
                            break;
                        case "mbertin@oci.fr":
                            evenementHub.assigneA = "MB";
                            break;
                       default:
                            evenementHub.assigneA = "PC";
                            break;
                    }

                    const state = { evenementHub };
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, state);
                }
            }
            else {
                Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
            }
        });
    };

    _enregistrer = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Enregistrement de l\'évènement en cours',
        });

        const { idTicket, onSave } = this.props;
        const evenementHub = {
            idTicket,
            ...this.state.evenementHub
        };

        DataTicket._onEnregistrementEvenementHub(evenementHub).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null)
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, {}, onSave);
            else
                Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
        });
    };

    _onOpen = () => {
        const { idEvenement } = this.props;
        this.setState({ ...FicheEvenementHub.defaultState });
        if (idEvenement)
            this._chargementDonnees();
    };

    _onVerificationFormulaire = () => {
        Immocom.fiche()._validationFormulaire(this, 'EvenementHub', this.state.evenementHub, (this.state.evenementHub.idEvenement > 0 ? 'Modification' : 'Création'));
    };

    render = () => {

        const { idEvenement, isOpen, onDismiss } = this.props;
        const { onActiveBoutonEnregistrer, evenementHub } = this.state;

        const today = new Date();
        if (today.getDate() >= 23) // La facturation a souvent lieu le 23 du mois, date à laquelle on saisit nos temps le mois suivant
            today.setMonth(today.getMonth() + 1)
        const currentYear = today.getFullYear();
        const currentMonth = today.toLocaleString("fr-fr", { month: "long" });

        return <EUIPanel
            headerText={!!idEvenement ? "Edition d'un évènement" : "Nouvel événement"}
            isFormValid={onActiveBoutonEnregistrer}
            isOpen={isOpen}
            onDismiss={onDismiss}
            onOpen={this._onOpen}
            onSave={this._enregistrer}
        >
            <MessageBars
                errorMessage={this.state.errorMessage}
                warningMessage={this.state.warningMessage}
                onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
            />

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            {/* compte */}
            <ComboBoxSalariesScribaNet
                onChange={(event, option, index, value, item) => Scriba.state().setObjetPropriete(this, "evenementHub", "assigneA", option.key !== "0" ? option.key : null, this._onVerificationFormulaire)}
                onLoad={!!idEvenement // A la création, récupérer automatiquement si possible l'utilisateur connecté
                    ? undefined
                    : (selectedItem, items) => {
                        const loginCompte = sessionStorage.getItem("loginCompte");
                        const compte = items.find(item => `ImmocomGestNat_${item.key}`.toLowerCase() === loginCompte.toLowerCase());
                        if (!!compte)
                            Scriba.state().setObjetPropriete(this, "evenementHub", "assigneA", compte.key, this._onVerificationFormulaire);
                    }
                }
                selectedKey={evenementHub.assigneA}
            />

            {/* projet */}
            <ComboBoxProjetHub
                onChange={(event, option, index, value, item) => Scriba.state().setObjetPropriete(this, "evenementHub", "idProjet", option.key, this._onVerificationFormulaire)}
                onLoad={!!idEvenement // A la création, récupérer automatiquement si possible le projet de l'année en cours
                    ? undefined
                    : (selectedItem, items) => {
                        const projet = items.find(item => item.nom === currentYear.toString());
                        if (!!projet)
                            Scriba.state().setObjetPropriete(this, "evenementHub", "idProjet", projet.idProjet, this._onVerificationFormulaire);
                    }
                }
                selectedKey={evenementHub.idProjet}
            />

            {/* phase */}
            <ComboBoxPhaseHub
                idProjet={evenementHub.idProjet}
                onChange={(event, option, index, value, item) => Scriba.state().setObjetPropriete(this, "evenementHub", "nomPhase", option.key, this._onVerificationFormulaire)}
                onLoad={!!idEvenement // A la création, récupérer automatiquement si possible la phase de l'année en cours
                    ? undefined
                    : (selectedItem, items) => {
                        const phase = items.find(item => item.phase === currentYear.toString());
                        if (!!phase)
                            Scriba.state().setObjetPropriete(this, "evenementHub", "nomPhase", phase.phase, this._onVerificationFormulaire);
                    }
                }
                selectedKey={evenementHub.nomPhase}
            />

            {/* tâche */}
            <ComboBoxTacheHub
                idProjet={evenementHub.idProjet}
                nomPhase={evenementHub.nomPhase}
                onChange={(event, option, index, value, item) => Scriba.state().setObjetPropriete(this, "evenementHub", "idTache", option.key, this._onVerificationFormulaire)}
                onLoad={!!idEvenement // A la création, récupérer automatiquement si possible la tâche du moins en cours
                    ? undefined
                    : (selectedItem, items) => {
                        const tache = items.find(item => item.nom.toLowerCase() === currentMonth.toLowerCase());
                        if (!!tache)
                            Scriba.state().setObjetPropriete(this, "evenementHub", "idTache", tache.idTache, this._onVerificationFormulaire);
                    }
                }
                selectedKey={evenementHub.idTache}
            />

            <TextFieldTemps
                label="Temps passé"
                onChange={(event, newValue, suffix) => Scriba.state().setObjetProprietes(this, "evenementHub", [["tempsPasseFormate", newValue], ["tempsPasseType", suffix]], this._onVerificationFormulaire)}
                value={evenementHub.tempsPasseFormate}
                suffix={evenementHub.tempsPasseType}
            />

            <TextFieldTemps
                label="Temps débité"
                onChange={(event, newValue, suffix) => Scriba.state().setObjetProprietes(this, "evenementHub", [["tempsDebiteFormate", newValue], ["tempsDebiteType", suffix]], this._onVerificationFormulaire)}
                value={evenementHub.tempsDebiteFormate}
                suffix={evenementHub.tempsDebiteType}
            />

            {/* statut */}
            <ComboBoxStatutEventHub
                onChange={(event, option) => Scriba.state().setObjetPropriete(this, "evenementHub", "idEvenementStatut", option.key, this._onVerificationFormulaire)}
                selectedKey={this.state.evenementHub.idEvenementStatut}
            />

        </EUIPanel>;
    };

};